<template>
  <v-dialog v-model="show" hide-overlay fullscreen scrollable transition="dialog-bottom-transition">
    
    <div id="myDiv" ref="myDiv"></div>
      <v-card v-if="this.options.request" class="background">
        <v-toolbar flat dark color="primary">
        <v-btn v-if="standardEditViewMode" icon dark @click="this.cancel">
              <v-icon>close</v-icon>
            </v-btn>
            <v-btn v-if="providerEditViewMode" icon dark @click="backToStandardMode()">
              <v-icon>arrow_back_ios</v-icon>
            </v-btn>
            <v-toolbar-title>Records Request</v-toolbar-title>
            <v-spacer></v-spacer>
            </v-toolbar>

        <!-- Content -->
        <v-card-text class="card-text">

<v-container class="fade-in one" v-if="standardEditViewMode" grid-list-md>
          <v-layout row wrap>
            <v-flex xs12 sm6>
            <v-card flat>
              <v-card-text>
                <v-layout style="margin-bottom:10px;" row>
                <span class="dialogSectionTitle">Request</span>
                <v-spacer/>
                <span class="status">{{ options.request.status }}</span>
              </v-layout> 
              <v-divider/>
              <v-layout style="margin-top:10px;" row>
                <span class="dialog-title">Patient</span>
                <v-spacer/>
                <span class="content">{{ options.patient.firstName + " " + options.patient.lastName }}</span>
              </v-layout> 

              <v-layout row>
                <span class="dialog-sub-title">Birthdate</span>
                <v-spacer/>
                <span class="content">{{ convertDate(options.patient.birthdate) }}</span>
              </v-layout> 

              <v-layout row>
                <span class="dialog-sub-title">Phone number</span>
                <v-spacer/>
                <span class="content">{{ options.patient.phone }}</span>
              </v-layout> 

              <v-layout row>
                <span class="dialog-sub-title">Address</span>
                <v-spacer/>
                <span class="content">{{ options.patient.address.line1 + ", " + options.patient.address.city + " " + options.patient.address.zip}}</span>
              </v-layout>

              <v-layout row>
                <span class="dialog-title">Dates of Service</span>
                <v-spacer/>
                <span class="content">{{ convertDate(options.request.start) }} - {{ convertDate(options.request.end) }}</span>
              </v-layout>

              <v-layout row>
                <span v-if="options.provider" class="dialog-title">Provider</span>
                <v-spacer/>
                <span class="content">{{ returnProviderDisplayName() }}</span>
              </v-layout> 

              <v-layout row v-if="options.provider && options.provider.address">
                <span class="dialog-sub-title">Address</span>
                <v-spacer/>
                <span class="content">{{ options.provider[0].address.line1 + ", " + options.provider[0].address.city + " " + options.provider[0].address.zip}}</span>
              </v-layout> 

              <v-layout row v-if="options.provider">
                <span class="dialog-sub-title">Phone</span>
                <v-spacer/>
                <span class="content">{{ options.provider[0].phone }}</span>
              </v-layout> 

              <v-layout row v-if="options.provider">
                <span class="dialog-sub-title">Fax</span>
                <v-spacer/>
                <span class="content">{{ options.provider[0].fax }}</span>
              </v-layout>

<!-- 
              <v-layout v-if="options.provider" row >
                <v-spacer></v-spacer>
                <v-btn @click="editCurrentProvider()" left flat small color="primary" style="min-width:0; font-weight:700;" >EDIT PROVIDER</v-btn>
              </v-layout>

              
-->

<v-text-field 
                      label="Provider Notes"
                        v-model="editProviderNote"
                        multi-line
                      ></v-text-field>
                      <v-layout>
            <v-spacer></v-spacer>
         
              <v-btn @click="submitProviderNote()" color="primary" :disabled="!this.providerNoteHasBeenEdited" left depressed style="min-width:0; font-weight:700;" >Update Provider Note</v-btn>
              </v-layout>

              </v-card-text>
              </v-card>
              </v-flex>
            

              <v-flex xs12 sm6>
            <v-card flat>
              <v-card-text column>
                <v-layout style="margin-bottom:10px;" row>
                  <span class="dialogSectionTitle">Action</span>
                  <v-spacer/>
                  <span class="status">{{ suggestedAction }}</span>
                </v-layout> 
                <v-divider/>
                <v-layout style="margin-top:10px;" v-if="standardEditViewMode && options.provider && !this.completedMode" column>
                <span v-if="this.options.request.status === 'SENT'" class="message">This request has been sent. Please verify delivery and ensure that the practice is processing the request in a timely manner.</span>
                <span v-if="this.options.request.status === 'NEEDS_FAX_NUMBER'" class="message">This request needs a fax number. Please contact the provider office and verify the best number use for a medical records request. After updating the field below, the system will send the fax.</span>

                  <v-form class="pa-2 mt-2">
                    
                    <v-layout v-if="options.provider" column>
                      <v-text-field flat
              label="Phone"
              
              v-model="editPhone"
              ></v-text-field>

              <v-text-field flat
              label="Medical Records Fax"
              
              v-model="editFax"
              ></v-text-field>

              <v-text-field flat
              label="Medical Records Email"
              
              v-model="editEmail"
              ></v-text-field>
              <v-text-field prepend-icon="event" class="mt-1 mb-1" hint="mm/dd/yyyy" mask="##/##/####" persistent-hint v-model="nextFollowUpDate" label="Next Follow Up"></v-text-field>

                    </v-layout>
                  </v-form>
                  <v-layout row>
                    <v-spacer></v-spacer><v-btn :disabled="!edit" @click="submit" color="primary">Update</v-btn>
                  </v-layout>
              </v-layout>

              <v-layout style="margin-top:10px;" v-if="completedMode" column>
  
                  <span class="message">This request has been marked as completed. No further action is needed.</span>
        
              </v-layout>

              <v-layout style="margin-top:10px;" v-if="proposeSuggestedProviderMode && !this.options.provider" column>
  
                  <span class="message">This request is missing full provider information but a potential matching provider has been found. Review the proposed provider information, edit the data for accuracy and display purposes and attach the provider to this request to continue.</span>
                      <v-layout>
            <v-spacer></v-spacer>
         
              <v-btn @click="addGoogleProvider()" color="primary" left flat style="min-width:0; font-weight:700;" >Review Provider</v-btn>
              </v-layout>
              
              </v-layout>

              </v-card-text>
              </v-card>
                </v-flex>
             
          </v-layout>
</v-container>

<v-container v-if="providerEditViewMode" grid-list-md>
  <v-card class="fade-in one"  flat>
    <v-form v-model="suggestedProviderValid">
    <v-card-text>
          <v-layout row wrap>
            
            <v-flex xs12 sm6 offset-sm6>
              
              <v-layout row>
                
      
                <v-radio-group row v-model="suggestedProvider.type" blue >
              <v-radio label="Individual" value="INDIVIDUAL"></v-radio>
              <v-radio label="Organization" value="ORGANIZATION"></v-radio>
            </v-radio-group>
              </v-layout>
            </v-flex>
            
            <v-flex xs12 sm6>
            <v-layout column class="pa-1">
            

            

          <v-text-field v-show="this.suggestedProvider.type === 'ORGANIZATION'" flat
              label="Organization Name"
              v-model="this.suggestedProvider.organizationName"
              ></v-text-field>

              <v-text-field v-show="this.suggestedProvider.type === 'INDIVIDUAL'" flat
              label="First Name"
              v-model="this.suggestedProvider.firstName"
              ></v-text-field>
         
            
              <v-text-field v-show="this.suggestedProvider.type === 'INDIVIDUAL'" flat
              label="Last Name"
              v-model="this.suggestedProvider.lastName"
              ></v-text-field>

                <v-text-field v-show="this.suggestedProvider.type === 'INDIVIDUAL'" flat
                label="Credentials"
                v-model="this.suggestedProvider.credentials"
                ></v-text-field>
          
              <v-text-field flat
              label="Phone"
              
              v-model="this.suggestedProvider.phone"
              ></v-text-field>

              <v-text-field flat
              label="Medical Records Fax"
              
              v-model="this.suggestedProvider.fax"
              ></v-text-field>

              <v-text-field flat
              label="Medical Records Email"
              v-model="this.suggestedProvider.email"
              ></v-text-field>


           
             </v-layout>
            </v-flex>
           

            

            
<v-flex xs12 sm6>
  <v-layout column class="pa-1">
              <v-text-field flat
              label="Street Address"
              required
              v-model="this.suggestedProvider.address.line1"
              ></v-text-field>

              <v-text-field flat
              label="Address Line 2"
              v-model="this.suggestedProvider.address.line2"
              ></v-text-field>

              <v-text-field flat
              label="City"
              required
              v-model="this.suggestedProvider.address.city"
              ></v-text-field>

            <v-text-field flat
              label="State"
              required
              v-model="this.suggestedProvider.address.state"
              ></v-text-field>

              <v-text-field flat
              label="Zip"
              required
              v-model="this.suggestedProvider.address.zip"
              ></v-text-field>
              </v-layout>
              </v-flex>
            
  
          </v-layout>
          <v-layout>

            <v-spacer></v-spacer>
         
              <v-btn @click.native="addUpdateProvider()"  color="primary" :disabled="!suggestedProviderValid" left flat style="min-width:0; font-weight:700;" >Save Provider Information</v-btn>
              </v-layout>
    </v-card-text>
    </v-form>
          </v-card>

</v-container>



<v-container v-if="standardEditViewMode" grid-list-md>
          <v-flex xs12>
    <v-text-field
                      label="Request Notes"
                        v-model="memo"
                        multi-line
                      ></v-text-field>
                      <v-layout>
                        <v-btn @click="cancelRequest()" color="red" left depressed style="min-width:0; font-weight:700; color:white;" >Cancel Request</v-btn>
            <v-spacer></v-spacer>
         
              <v-btn @click="submitNotes()" color="primary" :disabled="!this.memo && !this.edit" left depressed style="min-width:0; font-weight:700;" >Save Note</v-btn>
              </v-layout>
              <v-layout v-if="this.logStamps.length"  style="margin-top:30px;" column>
                <span class="dialog-sub-title">Request Log</span>
                
            <span v-for="logEntry in this.logStamps"
          :key="logEntry">{{logEntry}}</span>
            </v-layout>


</v-flex>
</v-container>

        </v-card-text>

        



      </v-card>
    </v-dialog>
</template>

<style lang="scss" scoped>

.card > .card__actions {
  flex: none;
}

.card__actions .btn {
  text-transform: capitalize;
}

.building {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-size: 24px;
  font-weight: 300;
  line-height: 1.33;
  text-align: center;
  color: white;
}

.content {
  font-size: 14px;
  /* line-height: 22px; */
  font-weight: 300;
  color: #515151;
  text-align: right;
  line-height: 35px;
}

.message {
  font-size: 14px;
  /* line-height: 22px; */
  font-weight: 300;
  color: #515151;
  text-align: left;
  line-height: 18px;
}

.dialog-title {
  font-size: 14px;
  line-height: 35px;
  font-weight: 700;
  color: #323232;
  margin-bottom: 5px;
}

.dialog-sub-title {
  font-size: 14px;
  line-height: 35px;
  font-weight: 350;
  color: #323232;
  margin-bottom: 5px;
}

.status {
  font-size: 18px;
  font-weight: 700;
  color: #ff0000;
  text-align: right;
}

.dialog-small-title {
  font-size: 14px;
  font-weight: 200;
  color: #515151;
  text-align: right;
  line-height: 35px;
}

.dialog-divider {
  width: 90%;
  margin-left: 5%;
}

.background {
  background-color: #fafafa;
}

.strd-card {
  border: 1px solid #e6e6e8;
  background-color: white;
}
</style>

<script>
import Avatar from '@/core/components/Avatar'
import DialogMixin from '@/core/mixins/DialogMixin'
import FormTextarea from '@/core/components/FormTextarea'
import { mapActions, mapState } from 'vuex'
import dateFormat from 'date-fns/format'

export default {
  name: 'OneConfirmDialog',
  mixins: [DialogMixin],
  components: {
    Avatar,
    FormTextarea
  },
  data() {
    return {
      nextFollowUpDate: null,
      shouldShowProviderNotes: false,
      standardEditViewMode: false,
      providerEditViewMode: false,
      completedMode: false,
      standardUpdate: false,
      showFullProviderEdit: false,
      suggestedProviderValid: false,
      proposeSuggestedProviderMode: false,
      contentSet: false,
      request: null,
      edit: false,
      start: null,
      end: null,
      log: [],
      editPhone: null,
      editFax: null,
      editEmail: null,
      editProviderNote: null,
      providerNoteHasBeenEdited: false,
      editStatus: null,
      status: null,
      patient: null,
      statuses: [
        'SENDING',
        'SENT',
        'MISSING_PROVIDER',
        'NEEDS_FAX_NUMBER',
        'CANCELLED',
        'REJECTED',
        'COMPLETED'
      ],
      memo: null,
      fax: null,
      phone: null,
      backEndProviderObject: null,
      suggestedProvider: {
        googlePlaceID: '',
        type: '',
        firstName: '',
        lastName: '',
        credentials: '',
        specialization: '',
        organizationName: '',
        coveredEntityName: '',
        address: {
          line1: '',
          line2: '',
          city: '',
          state: '',
          zip: ''
        },
        phone: '',
        fax: '',
        email: '',
        notes: ''
      }
    }
  },
  watch: {
    editStatus() {
      if (this.editStatus !== this.options.request.status) {
        this.edit = true
      }
    },
    editPhone() {
      if (this.editPhone !== this.options.provider[0].phone) {
        this.edit = true
      }
    },
    editFax() {
      if (this.editFax !== this.options.provider[0].fax) {
        this.edit = true
      }
    },
    editEmail() {
      if (this.editEmail !== this.options.provider[0].email) {
        this.edit = true
      }
    },
    memo() {
      this.edit = true
    },
    editProviderNote() {
      if (this.editProviderNote !== this.options.provider[0].notes) {
        this.providerNoteHasBeenEdited = true
      }
    }
  },
  methods: {
    ...mapActions('admin', ['getPatient', 'setStatus', 'setProviderInfo', 'createProvider']),
    ...mapActions('provider', ['getProviderIDFromGooglePlacesID', 'getProviderInfo']),
    cancelRequest() {
      this.options.status = 'CANCELLED'
      this.setStatus({
        id: this.options.request._id,
        status: {
          status: this.options.status
        }
      })
      this.ok()
    },
    addUpdateProvider() {
      let removedBlankValues = {}
      removedBlankValues.address = {}
      if (this.suggestedProvider.address.line1 !== '') {
        removedBlankValues.address.line1 = this.suggestedProvider.address.line1
      }

      if (this.suggestedProvider.address.line2 !== '') {
        removedBlankValues.address.line2 = this.suggestedProvider.address.line2
      }

      if (this.suggestedProvider.address.city !== '') {
        removedBlankValues.address.city = this.suggestedProvider.address.city
      }

      if (this.suggestedProvider.address.state !== '') {
        removedBlankValues.address.state = this.suggestedProvider.address.state
      }

      if (this.suggestedProvider.address.zip !== '') {
        removedBlankValues.address.zip = this.suggestedProvider.address.zip
      }

      let vm = this

      Object.keys(this.suggestedProvider).forEach(function (key) {
        let value = vm.suggestedProvider[key]
        if (value !== '' && key !== 'address') {
          if (key === '_id' || key === 'googlePlaceID' || key === 'googlePlacesID' || key === 'affiliateCode' || key === 'coveredEntityName' || key === 'created' || key === 'modified' || key === 'notes' || key === 'modified' || key === 'npi') {
            // do nothing
          } else {
            if (value && value !== null && value !== 'undefined') {
              removedBlankValues[key] = value
            }
          }
        }
      })

      this.setProviderInfo({
        id: this.backEndProviderObject._id,
        info: removedBlankValues
      }).then(() => {
        this.getProviderInfo({ ids: [this.backEndProviderObject._id] }).then(providersList => {
          console.log(providersList)
          this.options.provider = providersList
        })
      })

      let statusHere = 'NEEDS_FAX_NUMBER'
      this.options.request.status = statusHere
      this.setStatus({
        id: this.options.request._id,
        status: {
          status: this.options.request.status,
          provider: this.backEndProviderObject._id
        }
      })

      this.backToStandardMode()
      // now update the provider
    },
    submitProviderNote() {
      // this should patch the provider with just the notes field
      this.setProviderInfo({
        id: this.options.provider[0]._id,
        info: {
          notes: this.editProviderNote
        }
      })
      this.options.provider[0].notes = this.editProviderNote

      this.providerNoteHasBeenEdited = false
    },
    submitNotes() {
      let userStamp = ''

      if (this.user) {
        userStamp = this.user.email
      }

      let unix = Math.round(+new Date() / 1000)
      if (this.memo !== '' && this.memo !== null) {
        this.options.request.log.push({ timestamp: unix, message: userStamp + ': ' + this.memo })
      }
      this.memo = null

      this.setStatus({
        id: this.options.request._id,
        status: {
          status: this.options.request.status,
          log: this.options.request.log
        }
      })
    },
    editCurrentProvider() {
      console.log('editing current provider')
      if (this.options.provider) {
        console.log(this.options)
        this.suggestedProvider = this.options.provider[0]
        this.providerEditViewMode = true
        this.standardEditViewMode = false
      }
    },
    addGoogleProvider() {
      if (this.suggestedProvider) {
        this.providerEditViewMode = true
        this.standardEditViewMode = false
      }
    },
    backToStandardMode() {
      this.providerEditViewMode = false
      this.standardEditViewMode = true
    },
    placesIDLookup(placesID) {
      const placeToPutThis = this.$refs.myDiv
      const google = window.google
      let request = {
        placeId: placesID
      }
      let vm = this
      let callback = function(place, status) {
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          console.log(place)
          let streetNumber = ''
          let streetName = ''
          let city = ''
          let state = ''
          let postalCode = ''
          let name = place.name
          place.address_components.forEach(component => {
            // is this type a street address?
            if (component.types[0] === 'street_number') {
              streetNumber = component.long_name
            }
            if (component.types[0] === 'route') {
              streetName = component.long_name
            }
            if (component.types[0] === 'locality') {
              city = component.long_name
            }
            if (component.types[0] === 'administrative_area_level_1') {
              state = component.short_name
            }
            if (component.types[0] === 'locality') {
              city = component.long_name
            }
            if (component.types[0] === 'postal_code') {
              postalCode = component.long_name
            }
          })

          let purePhone = place.formatted_phone_number.replace(/\D/g, '')

          vm.suggestedProvider.googlePlaceID = place.place_id
          vm.suggestedProvider.phone = purePhone
          vm.suggestedProvider.type = 'ORGANIZATION'
          vm.suggestedProvider.organizationName = name
          vm.suggestedProvider.address.line1 = streetNumber + ' ' + streetName
          vm.suggestedProvider.address.city = city
          vm.suggestedProvider.address.state = state
          vm.suggestedProvider.address.zip = postalCode
          vm.updateSuggestedProviderFromBackEnd()
        }
      }
      let service = new google.maps.places.PlacesService(placeToPutThis)
      service.getDetails(request, callback)
    },
    updateSuggestedProviderFromBackEnd() {
      this.getProviderIDFromGooglePlacesID({googlePlaceIDs: [this.suggestedProvider.googlePlaceID]}).then((data) => {
        // now call get provider
        let vm2 = this
        this.getProviderInfo({ ids: [data[0]._id] }).then(providersList => {
          vm2.backEndProviderObject = providersList[0]
          // reconcile the google data with the provider data.
          // back end should be preferred.
          // only for data where the google data is more complete

          let vm = vm2
          // replace everything in the suggested provider with the back end info
          Object.keys(this.backEndProviderObject).forEach(function (key) {
            let value = vm.backEndProviderObject[key]
            if (value !== '' && value !== null && key !== 'address') {
              vm.suggestedProvider[key] = value
            }
          })

          if (this.backEndProviderObject.address) {
            if (this.backEndProviderObject.address.line1 !== '') {
              this.suggestedProvider.address.line1 = this.backEndProviderObject.address.line1
            }

            if (this.backEndProviderObject.address.line2 !== '') {
              this.suggestedProvider.address.line2 = this.backEndProviderObject.address.line2
            }

            if (this.backEndProviderObject.address.city !== '') {
              this.suggestedProvider.address.city = this.backEndProviderObject.address.city
            }

            if (this.backEndProviderObject.address.state !== '') {
              this.suggestedProvider.address.state = this.backEndProviderObject.address.state
            }

            if (this.backEndProviderObject.address.zip !== '') {
              this.suggestedProvider.address.zip = this.backEndProviderObject.address.zip
            }
          }
        })
      })
    },
    returnProviderDisplayName() {
      if (this.options) {
        if (this.options.provider) {
          if (this.options.provider[0].firstName) {
            return this.options.provider[0].firstName + ' ' + this.options.provider[0].lastName + ' ' + this.options.provider[0].credentials
          }

          if (this.options.provider[0].coveredEntityName) {
            return this.options.provider[0].coveredEntityName
          }

          if (this.options.provider[0].organizationName) {
            return this.options.provider[0].organizationName
          }
        }
      }
    },
    convertDate(timestamp) {
      let d = new Date(timestamp * 1000)
      return d.getMonth() + 1 + '/' + d.getDate() + '/' + d.getFullYear()
    },
    unixDate(date) {
      if (date !== '') {
        const formatDate =
          date.slice(4, 8) + '.' + date.slice(0, 2) + '.' + date.slice(2, 4)
        // Format: '2012.08.10'
        return new Date(formatDate).getTime() / 1000
      }
    },
    submit() {
      // this is a catch all for updating the request. this should handle updating emails, updating phone numbers, and updating fax numbers.
      // if a fax number is updated, the request should return to a "sending"
      // did the fax number change? if so, update the status

      if (this.editFax !== this.options.provider[0].fax || this.options.request.status === 'NEEDS_FAX_NUMBER') {
        // the fax number changed. the provider should be updated as well as the status should be changed
        this.options.request.status = 'SENDING'
      }

      this.edit = !this.edit
      let unix = Math.round(+new Date() / 1000)

      if (
        this.options.provider[0].fax !== this.editFax ||
        this.options.provider[0].phone !== this.editPhone ||
        this.options.provider[0].email !== this.editEmail
      ) {
        console.log(this.editEmail)
        let infoToSend = {}
        if (this.editFax) {
          infoToSend.fax = Number(this.editFax)
        }
        if (this.editEmail) {
          infoToSend.email = this.editEmail
        }
        if (this.editPhone) {
          infoToSend.phone = Number(this.editPhone)
        }
        if (this.nextFollowUpDate) {
          infoToSend.nextFollowUp = this.unixDate(this.nextFollowUpDate)
        }
        let info = infoToSend
        this.options.request.log.push({ timestamp: unix, message: 'Updating provider information' })
        this.setProviderInfo({
          id: this.options.provider[0]._id,
          info
        })
      }

      this.setStatus({
        id: this.options.request._id,
        status: {
          status: this.options.request.status,
          log: this.options.request.log
        }
      })
    },
    cancelEdit() {
      this.edit = !this.edit

      if (this.options.provider) {
        this.options.provider[0].fax = this.fax
        this.options.provider[0].phone = this.phone
      }
      this.options.request.status = this.status
    },
    clickEdit() {
      this.edit = !this.edit

      if (this.options.provider) {
        this.fax = this.options.provider[0].fax
        this.phone = this.options.provider[0].phone
      }
      this.status = this.options.request.status
    },
    onClose() {
      this.edit = false
    },
    formatDate(timestamp) {
      let d = new Date(timestamp * 1000)
      let month = d.getMonth() + 1
      let day = d.getDate()
      let year = d.getFullYear()

      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return month + day + year
    },
    onOpen() {
      this.memo = null
      this.standardEditViewMode = true
      this.providerEditViewMode = false
      this.completedMode = false
      this.proposeSuggestedProviderMode = false
      if (this.options) {
        console.log('this is the selected element')
        console.log(this.options)
        if (this.options.request) {
          if (this.options.request.missingProviderInfo && !this.options.provider) {
            if (this.options.request.missingProviderInfo.includes(':')) {
              let placesIDArray = this.options.request.missingProviderInfo.split(':')
              let placesID = placesIDArray[1]
              this.placesIDLookup(placesID)
              // this should return a suggested provider
              this.proposeSuggestedProviderMode = true
            }
          }
          if (this.options.request.nextFollowUp) {
            this.nextFollowUpDate = this.formatDate(this.options.request.nextFollowUp)
          }
        }
      }

      if (this.options.provider) {
        this.standardEditViewMode = true
        this.providerEditViewMode = false
        this.editFax = this.options.provider[0].fax
        this.editPhone = this.options.provider[0].phone
        this.editEmail = this.options.provider[0].email
        this.editProviderNote = this.options.provider[0].notes
      }

      if (this.options.request.status === 'COMPLETED') {
        this.standardEditViewMode = true
        this.providerEditViewMode = false
        this.completedMode = true
      }

      this.editStatus = this.options.request.status
      this.contentSet = true
    },
    sortByDates(a, b) {
      let dateA = a.timestamp
      let dateB = b.timestamp
      if (dateA > dateB) {
        return 1
      }
      if (dateA < dateB) {
        return -1
      }
      return 0
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    showBuilding() {
      return this.options.unit && this.options.building
    },
    suggestedAction() {
      if (this.options.request.status === 'MISSING_PROVIDER') {
        return 'Add Provider'
      }
      if (this.options.provider && this.showFullProviderEdit) {
        return 'Editing Provider'
      }
      if (this.options.request.status === 'SENT') {
        return 'Verify Delivery'
      }
      if (this.options.request.status === 'NEEDS_FAX_NUMBER') {
        return 'Update Fax'
      }
      if (this.options.request.status === 'COMPLETED') {
        return 'Completed'
      }
      return ''
    },
    logStamps() {
      let logStrings = []
      let sortedLogs = this.options.request.log

      sortedLogs.sort(function(a, b) {
        a = new Date(parseInt(a.timestamp) * 1000)
        b = new Date(parseInt(b.timestamp) * 1000)
        return a > b ? -1 : a < b ? 1 : 0
      })
      sortedLogs.forEach(element => {
        let stamp = element.timestamp
        const ts = new Date(parseInt(stamp) * 1000)
        let stampString = dateFormat(ts, 'MMM D YYYY HH:MM:ss Z')
        let message = element.message

        let author = ' '

        let messageHere = message

        if (message.includes(':')) {
          let messageArray = message.split(':')
          let username = messageArray[0]

          if (username.includes('@')) {
            author = ' (' + username + '): '
            messageHere = messageArray[1]
          }
        }

        let fullString = stampString + author + messageHere
        logStrings.push(fullString)
      })
      return logStrings
    }
  },
  mounted() {
    this.$on('close', this.onClose)
    this.$on('open', this.onOpen)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialogs/RequestInfoDialog.vue